/**
 * Convertit un File en dataURL (pour l'aperçu de l'avatar).
 * Renvoie `null` si pas de fichier.
 */
export default function fileToDataURL(file) {
    return new Promise((resolve, reject) => {
      if (!file) return resolve(null);
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }
  